import { VERTICALS } from '@packages/types';
/**
 * @getVertical - Finds the vertical for a given vertical id
 * @return
 *
 * @example getVertical('general') // general
 * @example getVertical('general-services') // general
 */
export const getVertical = (findVertical) => VERTICALS.find((vertical) => findVertical.includes(vertical)) ?? VERTICALS[0];
